import script from "./ButtonMini.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonMini.vue?vue&type=script&setup=true&lang=js"

import "./ButtonMini.vue?vue&type=style&index=0&id=f0fd3f40&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0fd3f40"]])

export default __exports__